import BaseStore from './BaseStore';
import { ActionTypes } from '../Constants';

class UIStore extends BaseStore {
   private activeTab: string = 'scenes';
   private isSidebarOpen = true;
   private modalType: string | null = null;
   private modalData: Record<string, unknown> = {};
   private storageKey = 'ui.activeTab';

   constructor() {
      super();

      if (typeof window !== 'undefined') {
         const stored = window.localStorage.getItem(this.storageKey);
         if (stored) {
            this.activeTab = stored;
         }
      }

      this.register((action) => {
         switch (action.type) {
            case ActionTypes.SET_ACTIVE_TAB:
               this.activeTab = (action.tab as string) || this.activeTab;
               if (typeof window !== 'undefined') {
                  window.localStorage.setItem(this.storageKey, this.activeTab);
               }
               this.emitChange();
               break;

            case ActionTypes.TOGGLE_SIDEBAR:
               this.isSidebarOpen = !this.isSidebarOpen;
               this.emitChange();
               break;

            case ActionTypes.SHOW_MODAL:
               this.modalType = (action.modalType as string) || null;
               this.modalData = (action.modalData as Record<string, unknown>) || {};
               this.emitChange();
               break;

            case ActionTypes.HIDE_MODAL:
               this.modalType = null;
               this.modalData = {};
               this.emitChange();
               break;

            case ActionTypes.LOGOUT:
               this.activeTab = 'scenes';
               if (typeof window !== 'undefined') {
                  window.localStorage.removeItem(this.storageKey);
               }
               this.emitChange();
               break;

            default:
          // Do nothing
         }
      });
   }

   getActiveTab(): string {
      return this.activeTab;
   }

   getIsSidebarOpen(): boolean {
      return this.isSidebarOpen;
   }

   getModalType(): string | null {
      return this.modalType;
   }

   getModalData(): Record<string, unknown> {
      return this.modalData;
   }

   isModalOpen(): boolean {
      return this.modalType !== null;
   }
}

const uiStore = new UIStore();

export default uiStore;
